import React, { useContext, useEffect } from 'react';
import {
  triggerMultiStepTeachingBubbleWithLock,
  MultiStepTeachingBubbleContext,
} from '@bingads-webui-campaign-react/multi-step-teaching-bubble';
import { LayoutSizeScale, useLayoutResizeObserver } from '@bingads-webui-fluent-component/layout-size';
import { LayoutContext, Mode } from '@bingads-webui-react/app-layout-container';
import { TeachingBubbleConfigs } from './teaching-bubble-configs';

const getModeByLayoutSize = (layoutSize) => {
  const result = LayoutSizeScale[layoutSize] >= LayoutSizeScale.XL;

  return result;
};

export const BubbleRenderer = () => {
  const bubbleContext = useContext(MultiStepTeachingBubbleContext);
  const [layoutSize, setLayoutSize] = React.useState('S');
  useLayoutResizeObserver(setLayoutSize);
  const largeSize = getModeByLayoutSize(layoutSize);
  const { config: layoutConfig } = useContext(LayoutContext);

  useEffect(() => {
    if (largeSize && layoutConfig.content.mode === Mode.Expanded) {
      triggerMultiStepTeachingBubbleWithLock({
        ...bubbleContext,
        featureName: TeachingBubbleConfigs.featureName,
      });
    }
  }, [bubbleContext, largeSize, layoutConfig]);

  return <div />;
};
